<template>
  <div class="page-container" v-if="currentNews && currentNews.title">
    <h1 class="page-title">{{ currentNews.title }}</h1>
    <p class="page-date" v-if="currentNews.date">{{ currentNews.date }}</p>
    <div class="content" :class="langStore.currentLang.startsWith('zh') ? 'lang-zh' : 'lang-en'">
      <template v-for="(section, index) in contentSections" :key="index">
        <div class="content-section">
          <div class="text-block">
            <p :class="{ 'no-indent': isReferenceSection(section) }" v-html="section"></p>
          </div>
        </div>
        <div v-if="index === 0 && currentNews.other?.picture1?.url" class="content-section image-section">
          <div class="image-container">
            <img :src="currentNews.other.picture1.url">
            <p class="image-caption">{{ currentNews.other?.picture1?.caption }}</p>
          </div>
        </div>
        <div v-if="index === 1 && currentNews.other?.picture2?.url" class="content-section image-section">
          <div class="image-container">
            <img :src="currentNews.other.picture2.url">
            <p class="image-caption">{{ currentNews.other?.picture2?.caption }}</p>
          </div>
        </div>
        <div v-if="index === 2 && currentNews.other?.picture3?.url" class="content-section image-section">
          <div class="image-container">
            <img :src="currentNews.other.picture3.url">
            <p class="image-caption">{{ currentNews.other?.picture3?.caption }}</p>
          </div>
        </div>
      </template>
    </div>
  </div>
  <div v-else class="page-container">
    <p>新闻内容未找到</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLangStore } from '../../../pinia/stores/lang';
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';

const langStore = useLangStore();

const currentNews = computed(() => {
  const translationData = langStore.currentLang.startsWith('zh') ? zhData : enData;
  const newsList = translationData.pages.news.company.news.list;
  const newsItem = newsList.find((news: any) => news.id === 'cicc80kajiduan');
  return newsItem || {};
});

const contentSections = computed(() => {
  const content = (currentNews.value as any)?.content || '';
  return content ? content.split('---').filter((p: string) => p.trim()) : [];
});

const isReferenceSection = (section: string) => {
  const text = section.trim();
  return text.startsWith('论文链接：') || text.startsWith('Source:');
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/content-blocks.scss";

.page-container {
  overflow: auto;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Microsoft YaHei', Arial, 'PingFang SC', sans-serif;
}

.page-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  line-height: 1.4;
  text-align: center;
}

.page-date {
  color: #666;
  font-size: 14px;
  margin-bottom: 30px;
  text-align: right;
}

.content-section {
  margin-bottom: 20px;
}

.text-block {
  /* 中文正文首行缩进 2 个汉字位 */
  .content.lang-zh & p {
    font-size: 16px;
    line-height: 1.8;
    color: #333;
    margin-bottom: 15px;
    text-align: justify;
    text-indent: 2em;
  }

  /* 英文正文不缩进 */
  .content.lang-en & p {
    font-size: 16px;
    line-height: 1.8;
    color: #333;
    margin-bottom: 15px;
    text-align: justify;
    text-indent: 0;
  }

  p.no-indent {
    text-indent: 0;
  }

  /* 小标题蓝色 */
  :deep(h3) {
    color: #0066cc;
    font-weight: bold;
    margin-top: 24px;
    margin-bottom: 12px;
  }

  /* 链接蓝色可点击 */
  :deep(a) {
    color: #1677ff;
    text-decoration: underline;
    cursor: pointer;
  }

  :deep(a:hover) {
    color: #0958d9;
  }
}

.image-section {
  text-align: center;
}

.image-container {
  display: inline-block;
  margin: 10px 0;
}

.image-container img {
  max-width: 100%;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.image-caption {
  margin-top: 8px;
  font-size: 14px;
  color: #666;
}
</style>
